/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: any,
  status: string
};

const Wrapper = styled.div(
  ({ theme }) => ({
    alignItems: 'center',
    color: theme.color.success,
    display: 'flex',
    flexDirection: 'row',
    fontWeight: theme.fontWeight.demiBold
  }),
  ({ status, theme }) =>
    ({
      danger: {
        color: theme.color.danger
      },
      warning: {
        animation: 'pulse 1.4s infinite ease-in-out both',
        color: theme.color.warning
      },
      success: {
        color: theme.color.success
      },
      normal: {
        color: 'inherit'
      },
      default: {
        color: theme.color.basis4
      }
    }[status])
);

export const CountdownIcon = styled(({ className }) => (
  <span className={`${className} ion-ios-timer-outline`} />
))({
  lineHeight: 1
});

const Inner = styled.span(({ theme }) => ({
  paddingLeft: theme.spacing.tiny
}));

function CountdownClock({ children, status }: Props) {
  return (
    <Wrapper status={status}>
      <CountdownIcon />
      <Inner>{children}</Inner>
    </Wrapper>
  );
}

export default CountdownClock;
